import { createI18n } from 'vue-i18n'
import ko from './ko'
import en from './en'

function detectLocale(): 'ko' | 'en' {
  try {
    const saved = localStorage.getItem('locale')
    if (saved === 'ko' || saved === 'en') return saved
  } catch { /* ignore */ }
  return navigator.language.startsWith('ko') ? 'ko' : 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { ko, en },
})

export function setLocale(l: 'ko' | 'en') {
  i18n.global.locale.value = l
  try { localStorage.setItem('locale', l) } catch { /* ignore */ }
  document.documentElement.lang = l
}
